<template>
  <div class="content o">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0"
      >
        <nav aria-label="breadcrumb" role="navigation" class="m-0 px-4">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'Search' }"> Home</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
             Cart
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <h1 class="section_header px-4">Cart</h1>
      </div>
      <div class="md-layout-item md-size-100">
        <md-card class="shopping-cart">
          <md-card-content>
            <md-table v-model="cart" class="table-shopping">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Product" class="tabel-product">
                  <h4><b>{{ item.name }}</b></h4>
                </md-table-cell>
                <md-table-cell md-label="Description" class="td-name product">
                  <p v-if="item.area">Area: {{ item.area }}</p>
                  <p v-if="item.details">Industry: {{ item.details }}</p>
                  <p v-if="item.fullDetails.salesClass">Sales Class: {{ item.fullDetails.salesClass }}</p>
                  <p v-if="item.fullDetails.structure">Structure: {{ item.fullDetails.structure }}</p>
                  <p v-if="item.fullDetails.timeSeries">Time Series: {{ item.fullDetails.timeSeries }}</p>
                </md-table-cell>
                <md-table-cell md-label="Price" class="price">
                  <sup>$</sup>{{ item.price }}
                  <md-button class="md-danger" @click="removeCartItem(item.id)">
                    <md-icon>delete_outline</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
            <div class="table table-stats">
              <div class="td-price">
                <span class="total-label md-display-1 total">Total</span>
                <div class="td-total"><sup>$</sup>{{ total }}</div>
                <router-link v-if="cart.length" :to="{ name: 'Checkout' }">
                  <md-button class="md-info">
                    <md-icon>arrow_right_alt</md-icon>
                  </md-button>
                </router-link>
                <md-button v-if="!cart.length" class="md-info">
                  <md-icon>arrow_right_alt</md-icon>
                </md-button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {},
  data() {
    return {
      saveCartEmail: 'danny@bizminer.com',
      shoppingCartTable: [],
      loading: true,
    };
  },
  computed: {
    ...mapState({
      cart: (state) => state.cart.cart,
      subTotal: (state) => state.cart.subTotal,
      total: (state) => state.cart.total,
    }),
    shoppingTotal() {
      return this.shoppingCartTable.reduce((accumulator, current) => {
        return accumulator + current.amount;
      }, 0);
    },
  },
  methods: {
    getClass: function(item, id) {
      let classes = '';
      switch (item) {
        case 'person': {
          classes = 'md-info';
          break;
        }
        case 'edit': {
          classes = 'md-success';
          break;
        }
        case 'close': {
          classes = 'md-danger';
          break;
        }
      }
      switch (id) {
        case 1:
        case 5: {
          break;
        }
        case 2:
        case 4: {
          classes = `${classes} md-round`;
          break;
        }
        case 3: {
          classes = `${classes} md-simple`;
          break;
        }
      }
      return classes;
    },
    getAlignClasses: ({ id }) => ({
      'text-right': id,
    }),
    increaseQuantity(item) {
      item.qty++;
      this.computeAmount(item);
    },
    decreaseQuantity(item) {
      if (item.qty > 1) {
        item.qty--;
        this.computeAmount(item);
      }
    },
    computeAmount(item) {
      item.amount = item.qty * item.price;
    },
    async getCart() {
      await this.$store.dispatch('cart/list').then((res) => {
        this.loading = false;
      });
    },
    async removeCartItem(id) {
      let params = {
        product_id: id,
      };
      await this.$store.dispatch('cart/removeItem', params).then((res) => {
        this.loading = false;
        this.getCart();
        this.$store.dispatch(
          'alerts/success',
          'Cart item removed!'
        );
      });
    },
  },
  async created() {
    await this.getCart();
  },
};
</script>
<style lang="scss"></style>
